<template>
  <!-- 自定义二维码 -->
  <div class="showCustomBarCode_box">
    <van-nav-bar :title="barcode_name?barcode_name:'自定义二维码'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true"
                 :border="false" />
    <div class="fixedH"
         style="height: 1.22667rem;"></div>
    <div class="content">
      <div ref="QRcodeSrcImg"
           class="QRcodeSrcImg">
        <div class="ewm">
          <qrcode :text="QRCode"
                  :width="300"
                  :height="300" />
          <!-- <p class="p">{{ $t("home.text7") }}</p> -->
          <p class="p">
            <!-- 长按二维码识别进行简历投递 -->
          </p>
        </div>
        <van-cell-group :border="false">
          <van-cell :title="$t('reqrcode.qrTxt8')"
                    :value="userInfo.empcode" />
          <van-cell :title="$t('reqrcode.qrTxt9')"
                    :value="userInfo.empname" />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import qrcode from '@components/qrcode'
const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
import request from '@/utils/request2'
export default {
  components: {
    qrcode
  },
  data () {
    let barcode_type = this.$route.query.barcode_type
    let barcode_name = this.$route.query.barcode_name
    let barcode_url = this.$route.query.barcode_url
    return {
      userInfo,
      outtime: window.eastriver_barcode_outtime
        ? window.eastriver_barcode_outtime
        : 120,
      recommendUrl: window.eastriver_barcode_url
        ? window.eastriver_barcode_url
        : 'https://hyclound.cn:8019/EastRiver/QRCode',
      HKUrl: window.HKUrl || '',
      QRCode: '',
      barcode_type,
      barcode_name,
      barcode_url
    }
  },
  created () {
    this.barcode_type = this.$route.query.barcode_type
    this.barcode_name = this.$route.query.barcode_name
    this.barcode_url = this.$route.query.barcode_url
    // console.log(this.barcode_type, 'this.barcode_type', this.barcode_name);
    if (this.barcode_type == 0)
    {
      this.QRCode = this.barcode_url
    } else if (this.barcode_type == 1)
    {
      this.getQRCode()
    } else if (this.barcode_type == 2)
    {
      this.getHKQRCode()
    }
  },
  methods: {
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    },
    getQRCode () {
      // let res = request({
      //   url: this.recommendUrl,
      //   method: 'get',
      //   params: { CardSn: this.idno, DesKey: 12345678, Des: 0 }
      // })
      // 创建XML请求
      var ajaxObj = new XMLHttpRequest()
      // 以get形式进行发送请求
      ajaxObj.open(
        'get',
        this.recommendUrl +
        '?CardSn=' +
        this.barcode_url +
        '&DesKey=12345678&Des=0&outtime=' +
        this.outtime
      )
      // 请求结束断开
      ajaxObj.send()
      // 初始化变量（必要）
      // 转入： this转为function（）方法内部函数（重点）
      const that = this
      ajaxObj.onreadystatechange = function () {
        if (ajaxObj.readyState === 4 && ajaxObj.status === 200)
        {
          // 请求放回的结果以文本形式，使用JSON.parse()方法进行转为json形式
          var data = JSON.parse(ajaxObj.responseText)
          console.log('数据返回成功', ajaxObj.responseText)
          if (data.error == '0')
          {
            that.QRCode = data.QRCode
          } else
          {
            Notify({ type: 'danger', message: data.msg })
          }
        }
      }
    },
    getHKQRCode () {
      // 创建XML请求
      var ajaxObj = new XMLHttpRequest()
      // 以get形式进行发送请求
      ajaxObj.open('get', this.HKUrl + '?idno=' + Number(this.barcode_url))
      // 请求结束断开
      ajaxObj.send()
      // 初始化变量（必要）
      // 转入： this转为function（）方法内部函数（重点）
      const that = this
      ajaxObj.onreadystatechange = function () {
        if (ajaxObj.readyState === 4 && ajaxObj.status === 200)
        {
          that.QRCode = ajaxObj.responseText
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.showCustomBarCode_box {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    .van-hairline--bottom::after {
      border-bottom-width: 0;
    }
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__text {
      color: #fff;
      font-size: 24px;
      font-family: Source Han Sans CN;
    }
  }
  .van-dialog {
    /deep/.van-dialog__content {
      position: relative;
      height: 100%;
      text-align: center;
      .ewm {
        width: 4.52rem;
        margin: 0 auto;
        padding-top: 1rem;
        min-height: 5.52rem;

        img {
          width: 4.52rem;
          height: 4.52rem;
        }
      }
      p {
        width: 100%;
        margin-top: 0.5rem;
      }
      .van-icon {
        width: 28px;
        height: 28px;
        position: absolute;
        right: 40px;
        top: 32px;
      }
    }
  }
  .content {
    height: calc(100% - 92px);
    overflow: auto;
    background: #2b8df0;
    .QRcodeSrcImg {
      background: #2b8df0;
      padding: 30px 0;
      .ewm {
        background: #fff;
        margin: 0 auto;
        width: 80%;
        border-radius: 15px;
        padding: 30px 0 1px;
        img {
          width: 4.52rem;
          height: 4.52rem;
        }
        .p {
          font-size: 36px;
          width: 100%;
          margin-top: 0.5rem;
          text-align: center;
        }
      }
      .van-cell-group {
        margin: 30px auto 0;
        background: #fff;
        width: 80%;
        border-radius: 15px;
        padding: 20px;
      }
    }

    .foot {
      text-align: center;
      margin: 30px auto 0;
      width: 80%;
      .btn {
        border-radius: 15px;
        width: 100%;
        .van-button__content {
          .van-button__text {
            font-size: 36px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
